import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import Debug from 'debug';
import { Observable } from 'rxjs';
import * as fromFeature from '../reducers/invitation.reducer';

import { licenceActions } from '../actions/licence.actions';
import { CreateOrUpdateLicencePackageDto } from '../dtos/CreateLicencePackageDto.interface';

const debug = Debug('aumico:aumico-lib-users-fe:LicenceProvider');

export interface ILicenceProvider {
    dispatchGetLicencePackages: (organizationId: string) => void;
    dispatchAddPackage: (organizationId: string, licencePackage: CreateOrUpdateLicencePackageDto) => void;
    dispatchDeleteLicencePackage: (packageId: string, organizationId: string) => void;
    getError$: () => Observable<HttpErrorResponse>;
}

@Injectable({
    providedIn: 'root',
})
export class LicenceProvider implements ILicenceProvider {
    constructor(private readonly store: Store<fromFeature.AppState>) {
        debug('provider constructed');
    }
    dispatchAddPackage(organizationId: string, licencePackage: CreateOrUpdateLicencePackageDto) {
        this.store.dispatch(licenceActions.createLicence({ payload: { organizationId, dto: licencePackage } }));
    }

    dispatchUpdatePackage(licencePackage: CreateOrUpdateLicencePackageDto) {
        this.store.dispatch(licenceActions.updateLicence({ payload: licencePackage }));
    }
    dispatchGetLicencePackages(organizationId: string) {
        this.store.dispatch(licenceActions.get({ payload: organizationId }));
    }

    dispatchDeleteLicencePackage(packageId: string, organizationId: string) {
        this.store.dispatch(licenceActions.deleteLicence({ packageId, organizationId }));
    }

    getError$(): Observable<HttpErrorResponse> {
        return this.store.select(fromFeature.selectError);
    }
}
